export const pendoIds = {
   navHomeTab: "navHomeTab",
   navPatientTab: "navPatientTab",
   navLibraryTab: "navLibraryTab",
   navTeamTab: "navTeamTab",
   navProviderTab: "navProviderTab",

   btnPlaybackSearch: "btnPlaybackSearch",
   btnEmrSearch: "btnEmrSearch",
   btnSearchBoxInvitePatient: "btnSearchBoxInvitePatient",
   btnCloseSearchPatient: "btnCloseSearchPatient",
   btnSearchPatient: "btnSearchPatient",
   inputSearchPatient: "inputSearchPatient",
   btnFilterSearchPatient: "btnFilterSearchPatient",
   btnVideoCallButton: "btnVideoCallButton",

   btnProviderSettings: "btnProviderSettings",
   btnProviderChangePassword: "btnProviderChangePassword",
   btnProviderRequestTemplate: "btnProviderRequestTemplate",
   btnProviderReferral: "btnProviderReferral",
   btnProviderNotificationSettings: "btnProviderNotificationSettings",
   btnProviderLogout: "btnProviderLogout",
   btnProviderContentCreated: "btnProviderContentCreated",
   btnNoteExpiryPolicy: "btnNoteExpiryPolicy",

   iconFollowUnfollowPatient: "iconFollowUnfollowPatient",
   btnEditPatientInfo: "btnEditPatientInfo",
   btnSendPatientMessage: "btnSendPatientMessage",
   btnPlaybackConnect: "btnPlaybackConnect",

   tabHomeViewedPatients: "tabHomeViewedPatients",
   tabHomeMyPatients: "tabHomeMyPatients",
   bannerActivatePatients: "bannerActivatePatients",
   btnActivatePatients: "btnActivatePatients",
   logoProviderDashboard: "logoProviderDashboard",
   iconNotifications: "iconNotifications",
   iconInactiveList: "iconInactiveList",

   tabMyLibrary: "tabMyLibrary",
   tabSharedWithMe: "tabSharedWithMe",
   btnCreateLibraryContent: "btnCreateLibraryContent",

   tabProfileMyPatients: "tabProfileMyPatients",
   tabProfileViewedPatients: "tabProfileViewedPatients",
   tabProfileInpatients: "tabProfileInpatients",
   tabProfileOutpatients: "tabProfileOutpatients",
   btnProfileInvitePatient: "btnProfileInvitePatient",
   tabEveryoneProfileContent: "tabEveryoneProfileContent",
   tabProviderOnlyProfileContent: "tabProviderOnlyProfileContent",
   tabCareTeamProfileContent: "tabCareTeamProfileContent",
   tabFamilyFriendsProfileContent: "tabFamilyFriendsProfileContent",
   btnInputSearchCareTeam: "btnInputSearchCareTeam",
   btnInputSearchFamilyFriends: "btnInputSearchFamilyFriends",
   btnInputSearchProviderOnly: "btnInputSearchProviderOnly",
   btnInputSearchEveryone: "btnInputSearchEveryone",
   btnProviderCreateContent: "btnProviderCreateContent",
   btnCareTeamAddMember: "btnCareTeamAddMember",
   btnFamilyFriendAddMember: "btnFamilyFriendAddMember",
   btnContentViewToggle: "btnContentViewToggle",
   btnContentLoveIcon: "btnContentLoveIcon",
   btnContentSeenBy: "btnContentSeenBy",
   btnRestrictAllowDownload: "btnRestrictAllowDownload",
   btnDeleteContent: "btnDeleteContent",
   btnSendContent: "btnSendContent",
   btnContentOptions: "btnContentOptions",
   tabCreateMedia: "tabCreateMedia",
   tabCreateItem: "tabCreateItem",
   tabCreateScreenRecord: "tabCreateScreenRecord",
   tabCreateAudio: "tabCreateAudio",
   tabCreateVideo: "tabCreateVideo",
   tabLibrary: "tabLibrary",
   tabSharedWithMeContLibrary: "tabSharedWithMeContLibrary",
   tabMyLibraryContLibrary: "tabMyLibraryContLibrary",
   inputSearchContLibrary: "inputSearchContLibrary",
   btnRemoveCareTeam: "btnRemoveCareTeam",
   btnRemoveFamilyFriend: "btnRemoveFamilyFriend",
   btnPatientProfileVideoCall: "btnPatientProfileVideoCall",
   btnPatientProfilePlaybackConnect: "btnPatientProfilePlaybackConnect",
   btnPatientProfileEditInfo: "btnPatientProfileEditInfo",
   btnPatientProfileCopyLink: "btnPatientProfileCopyLink",
   btnPatientProfileResendInvite: "btnPatientProfileResendInvite",
   btnPatientProfileMerge: "btnPatientProfileMerge",
   btnFollowUnfollowPatient: "btnFollowUnfollowPatient",
   btnPatientProfileActions: "btnPatientProfileActions",
   tabMyClinicalTeams: "tabMyClinicalTeams",
   tabAllClinicalTeams: "tabAllClinicalTeams",
   btnCreateClinicalTeam: "btnCreateClinicalTeam",
   btnEditProviderName: "btnEditProviderName",
   btnEditProviderPhoto: "btnEditProviderPhoto",
   btnEditProviderEmailInfo: "btnEditProviderEmailInfo",
   btnEditProviderPhoneInfo: "btnEditProviderPhoneInfo",
   btnEditProviderDepartment: "btnEditProviderDepartment",
   btnEditProviderSuffix: "btnEditProviderSuffix",
   btnEditProviderTitle: "btnEditProviderTitle",
   btnChangeWelcomeVideo: "btnChangeWelcomeVideo",
   btnDeleteWelcomeVideo: "btnDeleteWelcomeVideo",
   btnEditWelcomeVideoRecordingModal: "btnEditWelcomeVideoRecordingModal",
   btnPlayWelcomeVideoModal: "btnPlayWelcomeVideoModal",

   btnUpdatePatientInfoModal: "btnUpdatePatientInfoModal",
   btnContentShareModal: "btnContentShareModal",
   btnPlaybackConnectModal: "btnPlaybackConnectModal",
   btnEditProviderNameModal: "btnEditProviderNameModal",
   btnEditProviderDegreeModal: "btnEditProviderDegreeModal",
   btnCreateFolderModal: "btnCreateFolderModal",
   btnShareWithTeamModal: "btnShareWithTeamModal",
   btnUploadLibraryDocumentModal: "btnUploadLibraryDocumentModal",
   btnAddProviderToCareTeamModal: "btnAddProviderToCareTeamModal",
   btnAddProviderToClinicalTeamModal: "btnAddProviderToClinicalTeamModal",
   btnAddMemberToClinicalTeam: "btnAddMemberToClinicalTeam",
   btnInviteFamilyFriendsToCareTeamModal: "btnInviteFamilyFriendsToCareTeamModal",
   btnSendCreateContentModal: "btnSendCreateContentModal",
   btnSendPatientMessageModal: "btnSendPatientMessageModal",
   btnSendPatientMessageModals: "btnSendPatientMessageModals",
   btnUpdateProviderMobileModal: "btnUpdateProviderMobileModal",
   btnUpdateProviderEmailModal: "btnUpdateProviderEmailModal",
   btnUpdateProviderOfficeNumberModal: "btnUpdateProviderOfficeNumberModal",
   btnUpdateFollowStatusModal: "btnUpdateFollowStatusModal",
   btnInvitePatientModal: "btnInvitePatientModal",
   btnRemoveClinicalTeamMember: "btnRemoveClinicalTeamMember",
   btnCreateClinicalTeamModal: "btnCreateClinicalTeamModal",
   btnEditClinicalTeam: "btnEditClinicalTeam",
   btnUpdateClinicalTeamModal: "btnUpdateClinicalTeamModal",
   btnDeleteClinicalTeamModal: "btnDeleteClinicalTeamModal",
   btnResetProviderPassword: "btnResetProviderPassword",
   btnSearchPatientsIcon: "btnSearchPatientsIcon",
   btnCreateMediaId: "btnCreateMediaId",
   btnCreateMessageId: "btnCreateMessageId",
   btnCreateScreenRecordId: "btnCreateScreenRecordId",
   btnCreateAudioRecordId: "btnCreateAudioRecordId",
   btnCreateVideoRecordId: "btnCreateVideoRecordId",
   btnShareContentLibraryId: "btnShareContentLibraryId",
   btnShareContentLibraryArrowId: "btnShareContentLibraryArrowId",

   inputFieldProviderEmail: "inputFieldProviderEmail",
   inputFieldProviderPassword: "inputFieldProviderPassword",
   btnSignInProviderPassword: "btnSignInProviderPassword",
   btnForgotProviderPassword: "btnForgotProviderPassword",
   inputProviderLoginOtp: "inputProviderLoginOtp",
   btnProviderBacktoSignIn: "btnProviderBacktoSignIn",
   btnContinueProviderLogin: "btnContinueProviderLogin",
   inputFieldProviderMobile: "inputFieldProviderMobile",
   btnshowProviderQrCode: "btnshowProviderQrCode",
   providerQrCodeImage: "providerQrCodeImage",
   btnLinkHowQrCodeWorks: "btnLinkHowQrCodeWorks",
   inputFieldNewProviderPassword: "inputFieldNewProviderPassword",
   inputFieldNewProviderConfirmPassword: "inputFieldNewProviderConfirmPassword",
   btnResetPasswordContinue: "btnResetPasswordContinue",
   inputFieldNewProviderMobile: "inputFieldNewProviderMobile",
   btnNewProviderMobileContinue: "btnNewProviderMobileContinue",

   inputFileUploadControl: "inputFileUploadControl",
   inputFieldProviderFirstName: "inputFieldProviderFirstName",
   inputFieldProviderLastName: "inputFieldProviderLastName",
   inputFieldProviderTitle: "inputFieldProviderTitle",
   inputFieldProviderBusinessPhone: "inputFieldProviderBusinessPhone",
   inputFieldProviderDegree: "inputFieldProviderDegree",
   inputFieldProviderDepartment: "inputFieldProviderDepartment",
   inputFieldProviderOfficeAddress1: "inputFieldProviderOfficeAddress1",
   inputFieldProviderOfficeAddress2: "inputFieldProviderOfficeAddress2",
   inputFieldProviderPostalCode: "inputFieldProviderPostalCode",
   inputFieldProviderCityState: "inputFieldProviderCityState",
   btnSaveProviderDetails: "btnSaveProviderDetails",

   settingsTabProfile: "settingsTabProfile",
   settingsTabNotifications: "settingsTabNotifications",
   settingsTabPassword: "settingsTabPassword",
   settingsTabNotesAndTemplates: "settingsTabNotesAndTemplates",
   settingsTabReferral: "settingsTabReferral",
   settingsTabContentCreated: "settingsTabContentCreated",
};
